import { PropsWithChildren, useMemo } from "react";
import { createApiClient } from "../client";
import { ApiContext } from "./ApiClientContext";

/**
 * Reusable API provider component.
 * Provides the api client to its children
 */
export function ApiClientProvider({ children }: PropsWithChildren) {
  const client = useMemo(() => createApiClient(), []);

  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}
